import SendMail from './components/password/SendMail.vue';
import SetPassword from './components/password/Set.vue';
import Toast from './components/toast/Toast.vue';

const componentsGuest = (app) => {
  app.component('SendMail', SendMail);
  app.component('SetPassword', SetPassword);
  app.component('Toast', Toast);
};

export default componentsGuest;
